import React from "react";
import { Box, Container, Typography } from "@mui/material";
import fond1 from '../assets/fond1.png';
import LoginForm from "../components/forms/Login";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Connexion() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirectUrl = searchParams.get('redirect');
    return (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', backgroundImage: `url(${fond1})`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '100vh' }}>
            <Box sx={{ flexGrow: 1, px: 3 }}>
                <img src={require('../assets/logo-no-bg.png')} alt="Logo" style={{ width: '150px', margin: '20px auto', display: 'block' }} />
                <Typography variant="h4" align="center" sx={{ color: 'white', mb: 2 }}>Administration</Typography>
                <Container maxWidth='sm' sx={{ display:'flex', flexDirection:'column', minWidth: '300px', backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: 3, borderRadius: 2 }}>
                    <LoginForm {...{onLogin:()=>navigate('/')}} />
                </Container> 
            </Box>
        </Box>
    );
}